module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEhSURBVEhL7dQxSgNBFMbxFSEgnsA2QqzSCoraeo7Ea0gMWGhjFQRBrKPeIHU8gTcQ1BOYGDCo/290wrC+2c1ssBE/+MHO5M2bnWQ32X9+I3u4wSMmeMItNL9QlnGOd3xEXEB1laLmajJGB3XUsI5DvEKf95CcHejO9ZVsa8LIFkbQJruaSEkfWnjsRvF0obprN0rIA7Rww43iaUB1z24USRutr8tZtKjMHVa+r99g5ggq0FHDhI2K+BPoxD9yAF+ojarkBFp/6Ua5aAPd+QD5TfzGZfSUTbGJaJpQkRb4TfKNipyhNFfwC/zvMo9TLKE0a3iB1aRIUvxLkyIpq9ALYzWKSU746M4jOfrrvYfVzFIp+7CaWSpnCKthSDV/Lln2CVWRuf3rXieWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-watering-can/dark/24.png
// module id = 2556
// module chunks = 2